import { render, staticRenderFns } from "./UnauthorisedErrorLayout.vue?vue&type=template&id=3b80a22b&scoped=true"
import script from "./UnauthorisedErrorLayout.vue?vue&type=script&lang=js"
export * from "./UnauthorisedErrorLayout.vue?vue&type=script&lang=js"
import style0 from "./UnauthorisedErrorLayout.vue?vue&type=style&index=0&id=3b80a22b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80a22b",
  null
  
)

export default component.exports